import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    api.post("/auth/emergent-session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data.user);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { state: { user: data.user } });
      })
      .catch((err) => {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login");
      });
  }, [navigate, setUser, location]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F8F6]">
      <div className="text-center">
        <div className="font-serif-display text-3xl text-[#1A2421]">Signing you in…</div>
        <div className="mt-3 text-sm text-[#5C6B62]">Just a moment.</div>
      </div>
    </div>
  );
}
